import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { JobStatusEnum, WorkflowActivityStatusEnum } from "@/graphql.ts";
import { useWorkflowEditorStore } from "@/modules/workflow/stores/workflow-editor-store.ts";
import { ExtendedJobStatusEnum } from "@/modules/workflow/utils/types.ts";
import type { IAppState } from "@/redux/reducer.ts";

// TODO Optimize, transform as hook.
// We force the component to render on every status change,
// instead of just re-rendering on this boolean change.
export function isWorkflowInTerminalState(status?: ExtendedJobStatusEnum | JobStatusEnum | null) {
  return (
    status &&
    (status === ExtendedJobStatusEnum.Completed ||
      status === ExtendedJobStatusEnum.Error ||
      status === ExtendedJobStatusEnum.Terminated)
  );
}

export const isWorkflowRunning = (status?: ExtendedJobStatusEnum | null) => {
  return !isWorkflowInTerminalState(status) && status !== ExtendedJobStatusEnum.Ready;
};

export function isActivityInTerminalState(status?: WorkflowActivityStatusEnum | null) {
  return (
    status === WorkflowActivityStatusEnum.Completed ||
    status === WorkflowActivityStatusEnum.Terminated ||
    status === WorkflowActivityStatusEnum.Error
  );
}

export const useWorkflowSameExecutionUser = () => {
  const currentUsername = useSelector<IAppState, string | null>((state) => state.auth.session.username);
  const isSameUser = useWorkflowEditorStore(
    (state) => state.workflowEvent.executionUser?.toLowerCase() === currentUsername?.toLowerCase(),
  );

  return isSameUser;
};

export const useAllActivitiesComplete = () => {
  const [allActivitiesComplete, setAllActivitiesComplete] = useState(false);
  const nodes = useWorkflowEditorStore((state) => state.nodes);

  useEffect(() => {
    setAllActivitiesComplete(nodes.every((node) => node.data.status === WorkflowActivityStatusEnum.Completed));
  }, [nodes]);

  return allActivitiesComplete;
};

export const useSomeActivitiesWithStatus = () => {
  const [someActivitiesRan, setSomeActivitiesRan] = useState(false);
  const nodes = useWorkflowEditorStore((state) => state.nodes);

  useEffect(() => {
    setSomeActivitiesRan(nodes.some((node) => node.data.status != undefined));
  }, [nodes]);

  return someActivitiesRan;
};
